import React, { useCallback } from 'react';

import Hubspot from 'main/common/Hubspot';
import { useUserInfo } from 'queries/user-action/use-user-info';

import PlanSummary from '../Summary';

interface Props {
    className?: string;
}

const OemPlanSummary: React.FC<Props> = ({ className }) => {
    const { data: user } = useUserInfo();

    const onClick = useCallback(() => {
        if (user) {
            Hubspot.send(Hubspot.PRICING_CLICK, { email: user.email });
        }
    }, [user]);

    return (
        <PlanSummary
            name="OEM"
            price={{ primary: 'Custom', secondary: 'by request' }}
            button={{ text: 'Request invoice', to: '/company/contacts', onClick }}
            className={className}
        />
    );
};

export default OemPlanSummary;
